export default {
  props: {
    dateRange: Object,
    reportType: String
  },
  methods: {
    clicked(dateRangeId) {
      this.$emit("clicked", this.reportType, dateRangeId);
    }
  }
};